import { useAtom } from 'jotai';
import { filterListBottomSheetAtom } from './filterListBottomSheet.atom';
import { filterListBottomSheetStore } from './FilterListBottomSheetAtomProvider';
import { useEffect } from 'react';
import { useFilterListAtom } from '../filterList/useFilterListAtom';

export const useFilterListBottomSheetAtom = () => {
  const [filterListBottomSheetAtomValue, setFilterListBottomSheetAtomValue] =
    useAtom(filterListBottomSheetAtom, { store: filterListBottomSheetStore });
  const { filterListAtomValue } = useFilterListAtom();

  useEffect(() => {
    setFilterListBottomSheetAtomValue(filterListAtomValue);
  }, [filterListAtomValue, setFilterListBottomSheetAtomValue]);

  /**
   * - 필터 모달 내부에서 옵션을 선택할 때 사용
   * - 바텀시트 atom만 갱신하여 모달 내부의 totalCount/미리보기에만 반영
   * - 실제 검색결과/Screens 화면은 결과보기 버튼을 눌렀을 때 navigation.setParams를 통해서만 갱신됨
   */
  const setFilterListBottomSheetViaQueryValue: SetFilterListBottomSheetViaQueryValue =
    ({ queryName, queryValue }) => {
      setFilterListBottomSheetAtomValue(prev => ({
        ...prev,
        [queryName]: queryValue,
      }));
    };

  /**
   * - 필터 모달 내부 "초기화" 버튼에서 사용
   * - 바텀시트 atom만 비워 모달 내 선택값을 default 상태로 되돌림
   * - 실제 검색결과/Screens 화면에는 반영하지 않음 (결과보기 시점에만 반영)
   */
  const clearFilterListBottomSheet = () => {
    setFilterListBottomSheetAtomValue({});
  };
  return {
    filterListBottomSheetAtomValue,
    setFilterListBottomSheetViaQueryValue,
    clearFilterListBottomSheet,
  };
};

export type SetFilterListBottomSheetViaQueryValueProps = {
  queryName: string;
  queryValue: string | string[];
};

export type SetFilterListBottomSheetViaQueryValue = (
  props: SetFilterListBottomSheetViaQueryValueProps,
) => void;
